import React from "react";
import VideosEmbed from "../components/Embed";

const EmbedPage = () => {
  return <VideosEmbed />;
};

export default EmbedPage;
